export { getFilterSlugForPage, isFilterEnabledSlug } from '../utils';

/**
 * Parses monetary values from text, handling various formats:
 * - Simple: $300, $299.99
 * - With commas: $3,000, $1,234,567.89
 * - Complex text: "Up to $3,000", "Earn $3,000 bonus"
 *
 * @param text - The text containing a monetary value
 * @returns The parsed number, or 0 if no valid monetary value found
 *
 * @example
 * parseMonetaryValue("$300")           // returns 300
 * parseMonetaryValue("$3,000")         // returns 3000
 * parseMonetaryValue("Up to $3,000")   // returns 3000
 * parseMonetaryValue("$1,234.56")      // returns 1234.56
 * parseMonetaryValue("No bonus")       // returns 0
 */
export const parseMonetaryValue = (text: string | undefined): number => {
  if (!text) return 0;

  // Regex to match $ followed by numbers (with commas and optional decimal)
  const regex = /\$([\d,]+(?:\.\d+)?)/;
  const match = text.match(regex);

  if (!match) return 0;

  // Remove commas and parse to number
  const cleanValue = match[1].replace(/,/g, '');
  return parseFloat(cleanValue) || 0;
};

export const getStringValueForDriver = (value: string | number | null | undefined) => {
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return String(value);
  return String(value || '');
};

export const parsePercentageValue = (text: string | undefined): number => {
  if (!text) return 0;
  const matches = text.matchAll(/([\d.]+)%/g);
  const percentages = Array.from(matches).map(match => parseFloat(match[1]));
  if (percentages.length === 0) return 0;
  return Math.max(...percentages);
};
